import React, { useEffect } from "react";
import { Global } from "@mantine/core";

// Normalize format labels to valid CSS format() values
const FORMAT_MAP = {
  woff2: "woff2",
  woff: "woff",
  ttf: "truetype",
  truetype: "truetype",
  otf: "opentype",
  opentype: "opentype",
};

function buildFace(family, url, format, weight) {
  if (!family || !url) return null;
  const fmt = FORMAT_MAP[String(format || "").toLowerCase()];
  const src = fmt ? `url('${url}') format('${fmt}')` : `url('${url}')`; // tolerate bad/unknown format
  
  return {
    "@font-face": {
      fontFamily: family,
      src,
      fontWeight: weight,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
  };
}

export default function FontLoaderSimple({ styles }) {
  const font = styles?.global?.typography?.font;
  const family = font?.family;
  const normal = font?.normal;
  const bold = font?.bold;

  // Require family + normal url
  if (!family || !normal?.url) {
    return null;
  }

  const faces = [
    buildFace(family, normal.url, normal.format, 400),
    bold?.url ? buildFace(family, bold.url, bold.format, 700) : null,
  ].filter(Boolean);

  // Monitor font loading to detect failures (silently check, only report errors)
  useEffect(() => {
    if (!family || !normal?.url) return;
    
    // Check if font loads successfully after a delay
    const checkFontLoading = setTimeout(() => {
      // Check if font is actually loaded
      if (document.fonts) {
        document.fonts.ready.then(() => {
          const loaded = document.fonts.check(`16px ${family}`);
          if (!loaded) {
            console.error(`Font "${family}" failed to load. Common causes:`, {
              cause1: 'CORS: The server hosting the font must include Access-Control-Allow-Origin header',
              cause2: 'Invalid URL: Check if the font URL is accessible',
              cause3: 'Format mismatch: Ensure the format matches the actual font file type',
              testedUrl: normal.url,
              recommendation: 'Ask the client to add CORS headers to their font hosting server'
            });
          }
        });
      }
    }, 2000);
    
    return () => clearTimeout(checkFontLoading);
  }, [family, normal]);

  return faces.length ? <Global styles={faces} /> : null;
}